<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="pt-2 px-6">
		<vue-perfect-scrollbar class="scroll-area--form" :settings="settingsForm">
			<div class="vx-row">
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<vx-card :cardBorder="true" :noShadow="true" :title="$t('GeneralInformation')">
						<form data-vv-scope="update-job">
							<div class="vx-row">
								<div class="vx-col w-full">
									<vs-tooltip
										v-if="validateErrorProperty('name').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{ $t("Routing.Table.Name") }}</label>
										<span @click.prevent="showPromptError('name', $t('Routing.Table.Name'))"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">{{ $t("Routing.Table.Name") }}</label>
									<vs-input
										class="w-full"
										v-model="job.name"
										v-validate="'required'"
										name="name"
										:disabled="true"
									/>
									<span class="text-danger text-sm" v-show="errors.has('update-job.name')">{{
										$t("ResourceModule.BasicInfoForm.ValidMessages.Name")
									}}</span>
								</div>
							</div>
							<div class="vx-row mt-4">
								<div class="vx-col md:w-1/2 w-full">
									<vs-tooltip
										v-if="validateErrorProperty('penalty_cost').length > 0"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{ $t("Jobs.PenaltyCost") }}</label>
										<span @click.prevent="showPromptError('penalty_cost', $t('Jobs.PenaltyCost'))"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label"> {{ $t("Jobs.PenaltyCost") }}</label>
									<vs-input
										name="penaltyCost"
										class="w-full"
										icon-no-border
										v-model="job.penalty_cost"
										v-validate="'max_value:4294967295'"
										@keypress="validateAmountNumber"
									/>
									<span class="text-danger text-sm" v-show="errors.has('update-job.penaltyCost')">{{
										$t("OptimizerManager.ErrorMessage.TheTotalPointsFieldMustBe4294967295OrLower")
									}}</span>
								</div>
								<div class="vx-col md:w-1/2 w-full">
									<vs-tooltip
										v-if="
											validateErrorProperty('pickup_to_delivery_relative_detour_limit').length > 0
										"
										class="cursor-pointer"
										color="danger"
										position="left"
										:text="$t('ManualData.ShowErrors')"
									>
										<label class="vs-input--label mr-2">{{
											$t("Jobs.RelativeDeviationLimit")
										}}</label>
										<span
											@click.prevent="
												showPromptError(
													'pickup_to_delivery_relative_detour_limit',
													$t('Jobs.RelativeDeviationLimit')
												)
											"
											><vs-icon size="17px" icon="error" color="danger"></vs-icon
										></span>
									</vs-tooltip>
									<label v-else class="vs-input--label">
										{{ $t("Jobs.RelativeDeviationLimit") }}</label
									>
									<vs-input
										name="deviationLimit"
										class="w-full"
										icon-no-border
										v-model="job.pickup_to_delivery_relative_detour_limit"
										v-validate="'max_value:4294967295'"
										@keypress="validateAmountNumber"
									/>
									<span
										class="text-danger text-sm"
										v-show="errors.has('update-job.deviationLimit')"
										>{{
											$t(
												"OptimizerManager.ErrorMessage.TheTotalPointsFieldMustBe4294967295OrLower"
											)
										}}</span
									>
								</div>
							</div>
							<div class="vx-row mt-4">
								<div class="vx-col w-full">
									<small class="flex items-center date-label cursor-pointer">
										{{ $t("Jobs.MaximumTimeOfAbsoluteDeviation") }}
										<i
											class="material-icons text-primary ml-1"
											style="font-size: 16px"
											:title="$t('Jobs.SpecifiesTheMaximumAbsolute')"
										>
											info
										</i>
									</small>
									<div class="flex flex-row justify-between">
										<vs-input-number
											name="timeAbsoluteDeviation"
											v-model="absoluteDetourLimit.hours"
											class="w-1/4 mr-4"
											v-validate="'required'"
											:label="$t('RouterSelection.Hours')"
											:min="0"
										/>
										<vs-input-number
											name="timeAbsoluteDeviation"
											v-model="absoluteDetourLimit.minutes"
											class="w-full"
											v-validate="'required'"
											:label="$t('RouterSelection.Minutes')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberMinutes(absoluteDetourLimit.minutes, $event)"
										/>
										<vs-input-number
											name="timeAbsoluteDeviation"
											v-model="absoluteDetourLimit.seconds"
											class="w-full ml-4"
											v-validate="'required'"
											:label="$t('RouterSelection.Seconds')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberSeconds(absoluteDetourLimit.seconds, $event)"
										/>
									</div>
									<span
										class="text-danger text-sm"
										v-show="errors.has('update-job.timeAbsoluteDeviation')"
										>{{
											$t("Routing.AssignColumns.Text1") +
											" " +
											$t("Jobs.MaximumTimeOfAbsoluteDeviation") +
											" " +
											$t("Routing.AssignColumns.Text2")
										}}</span
									>
								</div>
							</div>
							<div class="vx-row mt-4">
								<div class="vx-col w-full">
									<small class="flex items-center date-label cursor-pointer">
										{{ $t("Jobs.MaximumPickupDeliveryTime") }}
										<i
											class="material-icons text-primary ml-1"
											style="font-size: 16px"
											:title="$t('Jobs.SpecifiesTheMaximumDuration')"
										>
											info
										</i>
									</small>
									<div class="flex flex-row justify-between">
										<vs-input-number
											name="pickupDeliveryTime"
											v-model="timeLimit.hours"
											class="w-1/4 mr-4"
											v-validate="'required'"
											:label="$t('RouterSelection.Hours')"
											:min="0"
										/>
										<vs-input-number
											name="pickupDeliveryTime"
											v-model="timeLimit.minutes"
											class="w-full"
											v-validate="'required'"
											:label="$t('RouterSelection.Minutes')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberMinutes(timeLimit.minutes, $event)"
										/>
										<vs-input-number
											name="pickupDeliveryTime"
											v-model="timeLimit.seconds"
											class="w-full ml-4"
											v-validate="'required'"
											:label="$t('RouterSelection.Seconds')"
											:min="0"
											:max="59"
											@keypress="validateInputNumberSeconds(timeLimit.seconds, $event)"
										/>
									</div>
									<span
										class="text-danger text-sm"
										v-show="errors.has('update-job.pickupDeliveryTime')"
										>{{
											$t("Routing.AssignColumns.Text1") +
											" " +
											$t("Jobs.MaximumPickupDeliveryTime") +
											" " +
											$t("Routing.AssignColumns.Text2")
										}}</span
									>
								</div>
							</div>
						</form>
					</vx-card>
				</div>
				<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
					<vx-card :cardBorder="true" :noShadow="true" style="height: 100%">
						<vs-tabs v-model="activeTabJob" class="tab-action-btn-fill-conatiner">
							<vs-tab
								:label="$t('PickUpService')"
								:icon="validateErrorProperty('pickups').length > 0 ? 'error' : ''"
							>
								<vs-tooltip
									v-if="validateErrorProperty('pickups').length > 0"
									class="cursor-pointer text-right"
									color="danger"
									position="left"
									:text="$t('ManualData.ShowErrors')"
								>
									<span @click.prevent="showPromptError('pickups', $t('PickUpService'))"
										><vs-icon size="17px" icon="error" color="danger"></vs-icon
									></span>
								</vs-tooltip>
								<job-assigned-visit-point-pickup :pickupPointJobsIds="pickupPointJobs" />
							</vs-tab>
							<vs-tab
								:label="$t('DeliveryService')"
								:icon="validateErrorProperty('deliveries').length > 0 ? 'error' : ''"
							>
								<vs-tooltip
									v-if="validateErrorProperty('deliveries').length > 0"
									class="cursor-pointer text-right"
									color="danger"
									position="left"
									:text="$t('ManualData.ShowErrors')"
								>
									<span @click.prevent="showPromptError('deliveries', $t('DeliveryService'))"
										><vs-icon size="17px" icon="error" color="danger"></vs-icon
									></span>
								</vs-tooltip>
								<job-assigned-visit-point-delivery :deliveryPointJobsIds="deliveryPointJobs" />
							</vs-tab>
							<vs-tab :label="$t('Vehicles.CostPerVehicle')">
								<div class="flex items-center justify-end">
									<job-select-vehicle
										:vehicleArray="propertiesListCostPerVehicles"
										:addVehicle="addVehicleArray"
										:deleteVehicle="deleteItemCostPerVehicles"
									/>
								</div>
								<vs-table
									v-model="selectedJob"
									multiple
									pagination
									search
									max-items="10"
									noDataText=""
									:data="propertiesListCostPerVehicles"
								>
									<template slot="thead">
										<vs-th>{{ $t("Identification") }}</vs-th>
										<vs-th>{{ $t("Cost") }}</vs-th>
										<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
									</template>
									<template slot-scope="{data}">
										<vs-tr :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data="data[indextr]">{{ tr.identification }}</vs-td>
											<vs-td :data="data[indextr]">
												<vs-input
													v-model="tr.cost"
													type="number"
													ref="inputCost"
													@keydown="onKeyDown($event, data[indextr])"
												/>
											</vs-td>
											<vs-td>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
													@click="deleteItemCostPerVehicles(indextr)"
												/>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
							</vs-tab>
						</vs-tabs>
					</vx-card>
				</div>
			</div>
		</vue-perfect-scrollbar>
		<div class="vx-row mt-4">
			<div class="vx-col w-full">
				<div class="flex flex-wrap items-center justify-end">
					<vs-button class="ml-auto" color="danger" @click.stop="closeSidebarJob()">{{
						$t("Cancel")
					}}</vs-button>
					<vs-button class="ml-4" @click.prevent="updateJob()">{{ $t("Crud.Update") }}</vs-button>
				</div>
			</div>
		</div>
		<vs-prompt
			color="danger"
			:title="$t('Errors') + ' ' + $t('TypeConfig.Form.Field') + ' ' + titlePromptErrorJob"
			:active.sync="activePromptErrorJob"
			:buttons-hidden="true"
		>
			<vs-list>
				<vs-list-item
					v-for="(item, index) of arrayErrors"
					:key="index"
					:title="index + 1 + '. ' + item.message"
				></vs-list-item>
			</vs-list>
		</vs-prompt>
	</div>
</template>

<script>
import {jobEditMixin} from "@/components/optimization/jobs/edit/JobEditMixin.js";

export default {
	mixins: [jobEditMixin],
};
</script>
<style lang="scss" scoped>
.scroll-area--form {
	margin: auto;
	width: 100%;
	min-height: 476px;
	max-height: 445px;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
	padding: 10px !important;
}
</style>
